import jwt_decode from 'jwt-decode';
import Cookies from 'js-cookie';
import base64 from 'base-64';
import utf8 from 'utf8';

// return the user data from the session storage
export const getUser = () => {
  const userStr = Cookies.get('api_token');
  if (userStr) return JSON.parse(userStr);
  else return null;
};

// remove the token and user from the session storage
export const removeUserSession = () => {
  localStorage.clear();
  sessionStorage.clear();
  Cookies.remove('api_token');
  Cookies.remove('us_retailer_login_session');
  Cookies.remove('us_retailer_session');
  Cookies.remove('customer_details');
};
// set the token and user from the session storage
export const setUserSession = (user, expireTime) => {
  const token = JSON.stringify(user);
  const { exp } = jwt_decode(user);

  Cookies.set('api_token', token, {
    expires: new Date(exp * 1000),
    
  });
};

export const getUserRole = () => {
  const decrypted = decryptToken();
  if (decrypted?.rle) return decrypted?.rle;
  else return null;
};


const decryptToken = () => {
  const token = getUser();
  if (token) {
    return jwt_decode(token);
  }
  return null;
};

export const setUserMenus = (data) => {
  localStorage.setItem('userMenus', data);
}

export const getUserMenus = () => {
  const userMenuData = localStorage.getItem('userMenus');
  if (userMenuData) return JSON.parse(userMenuData);
  else return null;
}


export const getMenuById = (menuId) => {
  const menus = JSON.parse(localStorage.getItem('userMenus')) || [];

  for (const menu of menus) {
    if (menu.id === menuId) return menu;
    if (menu.children?.length) {
      const child = menu.children.find(c => c.id === menuId);
      if (child) return child;
    }
  }
  return null;
};

export const hasPermission = (menuId, action = 'canRead') => {
  const menu = getMenuById(menuId);

  return !!menu?.permissions?.[action];
};
